(function (ws) {
    'use strict';

    ws.views.resetSBAPricing = ws.views.modal.extend({

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .qut-rest-price-continue': 'resetQuotePriceContinue'
        }),

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
            this.$button = this.$('.qut-rest-price-continue');
            this.eventAgg.on('resetQuotePricingSBA', this.resetQuotePricingSBA, this);
            this.applyModel = new ws.models.sbaApplyModel();
        },

        resetQuotePricingSBA: function (selected) {
            this.eventAgg.trigger(this.$el.attr('id'));
            if (this.$('.mergeQuoteResetQuotePricing').length) {
                this.$('.mergeQuoteResetQuotePricing').hide();
                this.$('.sbaQuoteResetQuotePricing').show();
            }

            this.$('input:radio[name=selectedOption]').filter('[checked=checked]').prop('checked', true);
            this.$button.attr('data-sba', selected);
        },

        /**
         * tigger the resetQuotePrices
         */
        resetQuotePriceContinue: function (e) {
            this.eventAgg.trigger('callingAddSBAApi', e.target.dataset.sba, this.$('input[name=selectedOption]:checked').val());
            this.closeModal();
        }
    });
}(westcon));
